import { Link } from 'react-router';
import { Button } from '../components';
import { StatusMessage } from './status-content';

export function ServerErrorContent({ onRetry }: { onRetry?: () => void }) {
  return (
    <StatusMessage
      code="Error 500"
      actions={
        <>
          {onRetry && <Button onClick={onRetry}>Try again</Button>}
          <Link to="/" className="self-center">
            Go to My view
          </Link>
        </>
      }
    >
      <p role="alert">Something went wrong while showing this page. The problem has been logged.</p>
    </StatusMessage>
  );
}
